import React, { useState, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faUndo, faPen, faTimes, faChevronRight, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import { Redirect, withRouter, Link } from "react-router-dom";
import axios from "axios";
import apiUrl from "../apiUrlConstant";
import Popup from "reactjs-popup";
import { PopupMessage } from "../utils/utils";
import { getUserRole, getUserType, getUserCategory, getLeadCategories, getLeadSubCategories, getLeadStatus } from "../utils/index";
import SimpleReactValidator from "simple-react-validator";
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Alert } from 'react-bootstrap';

const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class LeadAdd extends React.Component {
    state = {
        users: [],
        tenantIndustriesList: [
            'Accounting',
            'Acupuncture',
            'Admin / Support',
            'Advertising',
            'Aerospace & Defense',
            'Agriculture',
            'Airlines',
            'Allergy',
            'Ambulatory Surgery Center',
            'Apparel & Accessories',
            'Architecture',
            'Association / Non Profit',
            'Automotive',
            'Bar',
            'Biotechnology',
            'Bookstore',
            'Broker Dealer',
            'Asset use',
            'Business Support',
            'Cancer Center',
            'Cardiology',
            'Chemicals',
            'Childcare / Play',
            'Children\'s Apparel',
            'Chiropractic',
            'Cinemas / Theaters',
            'Clean Tech',
            'Coffee',
            'Construction',
            'Consulting',
            'Consumer Products',
            'Consumer Services',
            'Convenience Store',
            'Dentistry',
            'Department Store',
            'Dermatology',
            'Diagnostic / Medical Device',
            'Dialysis',
            'Distributors',
            'Drug Store',
            'Education',
            'Electronics',
            'Emergency Medicine',
            'Endocrinology',
            'Endoscopy',
            'Energy',
            'Engineering',
            'Entertainment & Leisure',
            'ENT / Ontology',
            'Executive Search / Staffing',
            'Eye Center',
            'Family Medicine',
            'Financial Services',
            'Fitness',
            'Food & Beverage',
            'Gastroenterology',
            'Government Agency',
            'Government Contractor',
            'Grocery',
            'Hardware',
            'Health & Beauty',
            'Healthcare (General)',
            'Hearing',
            'Hedge Fund',
            'Hematology',
            'Home Improvement / Furnishings',
            'Hospitality',
            'Infectious Disease',
            'Infusion',
            'Insurance',
            'Internal Medicine',
            'IT Services',
            'Jewelry',
            'Legal Services',
            'Liquor Store',
            'Manufacturing',
            'Materials',
            'Media',
            'Men\'s Apparel',
            'Mining',
            'Mortgage',
            'Multi-Specialty',
            'Nephrology',
            'Neurology',
            'Newsstand',
            'Nutrition',
            'Obstetrics & Gynecology',
            'Oil and Gas',
            'Oncology',
            'Ophthalmology',
            'Orthopedics',
            'Other',
            'Other Services',
            'Pain',
            'Pediatrics',
            'Personal Services',
            'Pharmaceuticals',
            'Pharmacy',
            'Physical Medicine & Rehabilitation',
            'Plastic Surgery',
            'Podiatry',
            'Private Equity',
            'Professional & Commercial Services',
            'Property Management',
            'Psychiatry',
            'Publishing',
            'Pulmonology',
            'Radiology & Medical Imaging',
            'Real Estate',
            'Restaurant (Fast Casual)',
            'Restaurant (Full Service)',
            'Restaurant (Other)',
            'Restaurant (Quick Service)',
            'Bank',
            'Retail (General)',
            'Retail (Specialty)',
            'Rheumatology',
            'Salon / Spa',
            'Serviced Office',
            'Shoes',
            'Sleep Center',
            'Social Services',
            'Sporting Goods',
            'Surgery',
            'Technology',
            'Technology Hardware',
            'Technology Software',
            'Telecommunications',
            'Therapeutic',
            'Toy / Gift / Craft',
            'Transportation',
            'Unknown',
            'Urgent Care',
            'Urology',
            'Utilities',
            'Virtual',
            'Warehousing',
            'Weight & Bariatrics',
            'Wholesale',
            'Women\'s Apparel',
            'Women\'s Center',
            'Wound Care & Hyperbaric'
        ],
        showAlert: false,
        tenantStatusList: ['Prospect', 'Client'],
        leadSegmentList: getLeadStatus(),
        requirementLists: [],
        stageLists: [],
        phoneNumerTypeLists: [],
        tenantStatus: '',
        tenantIndustries: '',
        isOpen: false,
        popupContent: "",
        messsagePopup: false,
        delete: false,
        redirect: false,
        isSearchable: true,
        isClearable: true,
        isDisabled: this.props.match.params.id !== undefined ? true : false,
        url: apiUrl.apiUrl.url + "/leads/create",
        id: undefined,
        initialValues: {
            tenant: '',
            contacts: [
                {
                    first_name: '',
                    last_name: '',
                    email: '',
                    title: '',
                    phone_no: '',
                    phone_no_type: ''
                }
            ]
        },
        isHotProspectFlag: false,
        currentSubStages: [],
        actionType: 'add',
        errorMessages: [],
        selectedStage:'',
        selectedSubStage:'',
        subStageError:false
    };

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
        });
    }

    async componentDidMount() {

        if (getUserRole() === 'admin') {
            var self = this;
            axios({
                method: "get",
                url: apiUrl.apiUrl.url + '/user/get-members',
            }).then(function (response) {
                self.setState({
                    users: response.data.data
                });
            });
        }

        if (this.props.match.params.id !== undefined) {
            this.state.url = apiUrl.apiUrl.url + "/leads/update?id=" + this.props.match.params.id;
            this.state.actionType = "update";

            fetch(`${apiUrl.apiUrl.url}/leads/get?id=${this.props.match.params.id}`, {headers}).then(
                (response) => {
                    return response.json();
                })
                .then((data) => {
                    this.setState({
                        initialValues: data.data,
                        isHotProspectFlag: data.data.is_hot_prospect == '1' ? true : false,
                    });
                }
                ).catch((error) => {
                    console.log(error);
                });


        } else {
            this.state.url = apiUrl.apiUrl.url + "/leads/create";
        }

        this.setState({});

        const subStages = await getLeadSubCategories();
        
        this.setState({
            requirementLists: [
                "Amenities", "Education", "Flex", "Industrial / Warehouse", "Lab",
                "Leisure",
                "Manufacturing",
                "Medical office",
                "Office",
                "Other",
                "Parking",
                "Residential",
                "Restaurant",
                "Retail",
                "Rooftop",
                "Storage",
                "Telecom",
                "Unspecified"
            ],
            stageLists: getLeadCategories(),
            subStages: subStages,
            phoneNumerTypeLists: ['Office', 'Mobile', 'Home', 'Other']
        });

        //console.log('Sub stages: ', this.state);
    }

    componentDidUpdate() {

    }

    redirectAfterSave = () => {
        this.setState({
            redirect: true,
            messsagePopup: false,
            delete: false,
            popupContent: "",
            initialValues: {
                tenant: '',
                contacts: []
            },
        });
    };

    render() {

        if (this.state.redirect == true) {
            let url = this.props.match;

            this.state.redirect = false;
            return <Redirect push to="/leads" />;
        }

        return (
            <div className="parentContainer">
                {this.renderForm()}
            </div>
        );
    }

    renderForm() {
        return (
            <>
                <div className="absoluteItemForTopBar">
                    <div className="new_breadcrumbs_design">
                        <ul className="d-flex align-items-center gap-3 p-0 m-0">
                            <li>
                                <Link to="/leads">Lead Module</Link>
                            </li>
                            <li><FontAwesomeIcon icon={faChevronRight} /></li>
                            <li>
                                <Link to="#">Add Lead</Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <Formik
                    enableReinitialize={true}
                    initialValues={this.state.initialValues}
                    onSubmit={(values, actions) => {

                        if (!this.validator.allValid()) {
                            this.validator.getErrorMessages();
                            this.validator.showMessages();
                            //this.forceUpdate();
                            return false;
                        }

                        //console.log(values);

                        var self = this;
                        axios({
                            method: "post",
                            url: this.state.url,
                            data: values,
                        }).then(function (response) {
                            if (response.data.status == 'success') {
                                self.setState({
                                    messsagePopup: true,
                                    popupContent: "Lead Saved Successfully!",
                                    url: `${apiUrl.apiUrl.url}/leads/create-category`
                                });

                            } else {
                                actions.setSubmitting(false);
                                console.log(response.data);

                                const errorMessages = Object.values(response.data.errors).flat().map((msg, index) => <li key={`error_${index}`}>{msg}</li>);
                
                                self.setState({
                                    showAlert: true,
                                    errorMessages: errorMessages
                                });
                            }
                        });
                    }}
                >
                    {({
                        values,
                        handleChange,
                        setFieldValue,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <>
                            {this.state.showAlert == true ? (
                                <Alert variant="danger">
                                    <ul className="m-0">
                                       {this.state.errorMessages}
                                    </ul>
                                    <span onClick={() => this.setState({ showAlert: false })}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                            <path fill="currentColor" d="M10.586 12L2.793 4.207l1.414-1.414L12 10.586l7.793-7.793l1.414 1.414L13.414 12l7.793 7.793l-1.414 1.414L12 13.414l-7.793 7.793l-1.414-1.414z" />
                                        </svg>
                                    </span>
                                </Alert>
                            ) : null}

                            <div className="unitFormContainerNew">
                                <Form
                                    autoComplete="off"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault(); // Prevent form submission on Enter key press
                                        }
                                    }}
                                >
                                    <div className="newGridSectionParent">

                                        <div className="newGridSectionForFormMain">
                                            <div className="gridColOneByThree textWithHrTag">
                                                {/* <hr className="m-0 mt-1" /> */}
                                                <h4>COMPANY</h4>
                                            </div>

                                            {getUserRole() === 'admin' && this.state.actionType !== 'update' && (
                                                <div className="newGridSectionInner">
                                                    <label>Assign To <span className="astrik">*</span></label>
                                                    <div className="position-relative">
                                                        <Field as="select" name="user_id" onChange={handleChange}>
                                                            <option value="">Select Member</option>
                                                            {this.state.users.map(user => (
                                                                <option key={user.id} value={user.id}>{user.name}</option>
                                                            ))}
                                                        </Field>
                                                        {this.validator.message("User", values.user_id, "required", { className: "text-danger" })}
                                                    </div>
                                                </div>
                                            )}

                                            <div className="newGridSectionInner">
                                                <label>
                                                    Lead Title <span className="astrik">*</span>
                                                </label>
                                                <div className="position-relative">
                                                    <Field type="text" name="title" maxlength="100"/>
                                                    {this.validator.message("Lead Title", values.title, "required", { className: "text-danger" })}
                                                </div>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>
                                                    {getUserCategory() == 'Landlord' ? 'Tenant' : 'Landlord'} <span className="astrik">*</span>
                                                </label>
                                                <div className="position-relative">
                                                    <Field type="text" name="tenant" maxlength="100" />
                                                    {this.validator.message("Tenant", values.tenant, "required", { className: "text-danger" })}
                                                </div>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>{getUserCategory() == 'Landlord' ? 'Tenant' : 'Landlord'} Industry</label>
                                                <div className="position-relative">
                                                    <Select
                                                        className="basic-single custom-select-style"
                                                        classNamePrefix="custom-select-style-inner"
                                                        name="tenant_industry"
                                                        onChange={(selectedOption) => {
                                                            setFieldValue('tenant_industry', selectedOption.value);
                                                        }}
                                                        value={{
                                                            label: values.tenant_industry,
                                                            value: values.tenant_industry,
                                                        }}
                                                        options={this.state.tenantIndustriesList.map((item) => ({
                                                            label: item,
                                                            value: item,
                                                        }))}
                                                    />
                                                </div>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>
                                                    {getUserCategory() == 'Landlord' ? 'Tenant' : 'Landlord'} Status
                                                </label>
                                                <div className="position-relative">
                                                    <Select
                                                        className="basic-single custom-select-style"
                                                        classNamePrefix="custom-select-style-inner"
                                                        name="tenant_status"
                                                        onChange={(selectedOption) => {
                                                            setFieldValue('tenant_status', selectedOption.value);
                                                        }}
                                                        value={{
                                                            label: values.tenant_status,
                                                            value: values.tenant_status,
                                                        }}
                                                        options={this.state.tenantStatusList.map((item) => ({
                                                            label: item,
                                                            value: item,
                                                        }))}
                                                    />
                                                </div>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>
                                                    <Field
                                                        type="checkbox"
                                                        style={{ width: "min-content", marginRight: "10px" }}
                                                        name="is_hot_prospect"
                                                        value="1"
                                                        checked={this.state.isHotProspectFlag}
                                                        onClick={(e) => {
                                                            const isChecked = e.target.checked;
                                                            this.setState({ isHotProspectFlag: isChecked });
                                                            handleChange(e);
                                                        }}
                                                    />
                                                    Hot Prospect
                                                </label>
                                                <div className="position-relative">

                                                </div>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>Lead Status <span className="astrik">*</span></label> 
                                                <div className="position-relative">
                                                    <Select
                                                        className="basic-single custom-select-style"
                                                        classNamePrefix="custom-select-style-inner"
                                                        name="lead_temperature"
                                                        onChange={(selectedOption) => {
                                                            setFieldValue('lead_temperature', selectedOption.value);
                                                        }}
                                                        value={{
                                                            label: values.lead_temperature,
                                                            value: values.lead_temperature,
                                                        }}
                                                        options={this.state.leadSegmentList.map((item) => ({
                                                            label: item.charAt(0).toUpperCase() + item.slice(1),
                                                            value: item,
                                                        }))}
                                                    />
                                                    {this.validator.message("Lead Segment", values.lead_temperature, "required", { className: "text-danger" })}
                                                </div>
                                            </div>

                                            <div className="gridColOneByThree textWithHrTag">
                                                <hr className="m-0 mt-1" />
                                                <h4>DEAL INFORMATION</h4>
                                                { this.state.subStageError==true && (                                        
                                                <Alert variant="danger">
                                                    <ul className="m-0">
                                                    <li>Please create a sub stage</li>
                                                    </ul>
                                                    <span onClick={() => this.setState({ subStageError: false })}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                                            <path fill="currentColor" d="M10.586 12L2.793 4.207l1.414-1.414L12 10.586l7.793-7.793l1.414 1.414L13.414 12l7.793 7.793l-1.414 1.414L12 13.414l-7.793 7.793l-1.414-1.414z" />
                                                        </svg>
                                                    </span>
                                                </Alert>
                                            )}
                                            </div>
                                            {this.state.actionType !== 'update' && (
                                                <>
                                                    <div className="newGridSectionInner">
                                                        <label>Stage<span className="astrik">*</span></label>
                                                        <div className="position-relative">
                                                            <Select
                                                                className="basic-single custom-select-style"
                                                                classNamePrefix="custom-select-style-inner"
                                                                name="stage"
                                                                onChange={(selectedOption) => {
                                                                    setFieldValue('stage', selectedOption.value);
                                                                    setFieldValue('sub_stage', ''); 
                                                                    setFieldValue('sub_stage_id', ''); // Reset sub_stage
                                                                    
                                                                    const subStages = this.state.subStages ? this.state.subStages[selectedOption.value.toLowerCase()] : undefined;

                                                                    
                                                                    this.setState({
                                                                        selectedStage: selectedOption.label,
                                                                        currentSubStages: subStages !== undefined ? subStages : [],
                                                                        subStageError: subStages !== undefined ? false : true
                                                                    });
                                                                }}
                                                                value={{
                                                                    label: this.state.selectedStage,
                                                                    value: values.stage,
                                                                }}
                                                                options={Object.entries(this.state.stageLists).map(([key, value]) => ({
                                                                    label: value,
                                                                    value: key,
                                                                }))}

                                                            />
                                                            {this.validator.message("Stage", values.stage, "required", { className: "text-danger" })}
                                                        </div>
                                                    </div>

                                                    <div className="newGridSectionInner">
                                                        <label>Sub Stage <span className="astrik">*</span></label>
                                                        <div className="position-relative">
                                                            <Select
                                                                className="basic-single custom-select-style"
                                                                classNamePrefix="custom-select-style-inner"
                                                                name="sub_stage"
                                                                onChange={(selectedOption) => {
                                                                    setFieldValue('sub_stage', selectedOption.originalLabel);
                                                                    setFieldValue('sub_stage_id', selectedOption.value);
                                                                    this.setState({
                                                                        selectedSubStage: selectedOption.label
                                                                    });
                                                                }}
                                                                value={{
                                                                    label: this.state.selectedSubStage,
                                                                    value: values.sub_stage,
                                                                }}
                                                                options={this.state.currentSubStages.map((item) => ({
                                                                    originalLabel: item.title,
                                                                    label: item.winning_probability ? `${item.title} - Winning Probability: (${item.winning_probability}%)` : item.title,
                                                                    value: item.id,
                                                                }))}
                                                            />
                                                            {this.validator.message("Sub stage", values.sub_stage, "required", { className: "text-danger" })}
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                            <div className="newGridSectionInner">
                                                <label>Requirement Type</label>
                                                <div className="position-relative">
                                                    <Select
                                                        className="basic-single custom-select-style"
                                                        classNamePrefix="custom-select-style-inner"
                                                        name="requirement_type"
                                                        onChange={(selectedOption) => {
                                                            setFieldValue('requirement_type', selectedOption.value);
                                                        }}
                                                        value={{
                                                            label: values.requirement_type,
                                                            value: values.requirement_type,
                                                        }}
                                                        options={this.state.requirementLists.map((item) => ({
                                                            label: item,
                                                            value: item,
                                                        }))}
                                                    />
                                                </div>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>Tags</label>
                                                <div className="position-relative">
                                                    <Field type="text" name="tags" maxlength="100" />
                                                </div>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>Reference Source</label>
                                                <div className="position-relative">
                                                    <Field type="text" name="reference_source" maxlength="100" />
                                                </div>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>Comment</label>
                                                <div className="position-relative">
                                                    <Field type="text" name="comment" maxlength="255"/>
                                                </div>
                                            </div>

                                            <div className="gridColOneByThree textWithHrTag">
                                                <hr className="m-0 mt-1" />
                                                <h4>CURRENT LOCATION</h4>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>Current Address</label>
                                                <div className="position-relative">
                                                    <Field type="text" name="current_address" maxlength="150" />
                                                </div>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>Floor | Space</label>
                                                <div className="position-relative">
                                                    <Field type="text" name="floor" maxlength="50" />
                                                </div>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>Lease Expiration</label>
                                                <div className="position-relative">
                                                    <Field type="date" name="lease_expiry" />
                                                </div>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>Current Area (sqft)</label>
                                                <div className="position-relative">
                                                    <Field type="text" name="current_area" maxlength="10" 
                                                        onInput={(e) => {
                                                            e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                            }
                                                        }
                                                    />
                                                </div>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>Current Rent (INR / psf)</label>
                                                <div className="position-relative">
                                                    <Field type="text" name="current_rent" maxlength="10"
                                                        onInput={(e) => {
                                                            e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                            }
                                                        }
                                                    /> 
                                                    {this.validator.message('Current rent', values.current_rent, 'numeric')}
                                                </div>
                                            </div>

                                            <div className="gridColOneByThree textWithHrTag">
                                                <hr className="m-0 mt-1" />
                                                <h4>ADD CONTACT</h4>
                                            </div>
                                            <FieldArray name="contacts">
                                                {({ insert, remove, push }) => (
                                                    <>
                                                        {values.contacts.length > 0 &&
                                                            values.contacts.map((contact, index) => (
                                                                <>
                                                                    <div className="newGridSectionInner">
                                                                        <label>First Name</label>
                                                                        <div className="position-relative">
                                                                            <Field name={`contacts.${index}.first_name`} type="text" maxlength="100" />
                                                                            {this.validator.message('First Name', values.contacts[index].first_name, 'alpha_space')}
                                                                        </div>
                                                                    </div>
                                                                    <div className="newGridSectionInner">
                                                                        <label>Last Name</label>
                                                                        <div className="position-relative">
                                                                            <Field name={`contacts.${index}.last_name`} type="text" maxlength="100" />
                                                                            {this.validator.message('Last Name', values.contacts[index].last_name, 'alpha_space')}
                                                                        </div>
                                                                    </div>
                                                                    <div className="newGridSectionInner">
                                                                        <label>Email</label>
                                                                        <div className="position-relative">
                                                                            <Field name={`contacts.${index}.email`} type="text" maxlength="100" />
                                                                            {this.validator.message('Email address', values.contacts[index].email, 'email')}
                                                                        </div>
                                                                    </div>
                                                                    <div className="newGridSectionInner">
                                                                        <label>Title</label>
                                                                        <div className="position-relative">
                                                                            <Field name={`contacts.${index}.title`} type="text" maxlength="100" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="newGridSectionInner">
                                                                        <label>Phone Number</label>
                                                                        <div className="position-relative">
                                                                            <Field name={`contacts.${index}.phone_no`} type="text" maxlength="15" />
                                                                            {this.validator.message('Phone Number', values.contacts[index].phone_no, 'phone')}
                                                                        </div>
                                                                    </div>
                                                                    <div className="newGridSectionInner">
                                                                        <label>
                                                                            Phone Number Type
                                                                        </label>
                                                                        <div className="position-relative">
                                                                            <Select
                                                                                key={index}
                                                                                className="basic-single custom-select-style"
                                                                                classNamePrefix="custom-select-style-inner"
                                                                                name={`contacts.${index}.phone_no_type`}
                                                                                onChange={(option) => {
                                                                                    setFieldValue(`contacts.${index}.phone_no_type`, option.value);
                                                                                    values.contacts[index].phone_no_type = option.value;
                                                                                }}
                                                                                value={{
                                                                                    label: values.contacts[index].phone_no_type,
                                                                                    value: values.contacts[index].phone_no_type,
                                                                                }}
                                                                                options={this.state.phoneNumerTypeLists.map((item) => ({
                                                                                    label: item,
                                                                                    value: item,
                                                                                }))}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="button_group d-flex align-items-center gap-2 justify-content-end gridColOneByThree">
                                                                        {index > 0 &&
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-danger"
                                                                                onClick={() => remove(index)}
                                                                            >
                                                                                Remove Contact
                                                                            </button>
                                                                        }
                                                                    </div>
                                                                    <div className="gridColOneByThree textWithHrTag">
                                                                        <hr />
                                                                    </div>
                                                                </>
                                                            ))}
                                                        <button
                                                            type="button"
                                                            className='addcontact_button gridColOneByThree'
                                                            onClick={() =>
                                                                push({
                                                                    first_name: '',
                                                                    last_name: '',
                                                                    email: '',
                                                                    title: '',
                                                                    phone_no: '',
                                                                    phone_no_type: ''
                                                                })
                                                            }
                                                        >
                                                            Add More Contact
                                                        </button>
                                                    </>
                                                )}
                                            </FieldArray>
                                            <div className="gridColOneByThree textWithHrTag">
                                                <hr className="m-0 mt-1" />
                                                <h4>ADD Requirements</h4>
                                            </div>
                                            <div className="newGridSectionInner">
                                                <label>Area Type</label>
                                                <div className="position-relative">
                                                    <Select
                                                        className="basic-single custom-select-style"
                                                        classNamePrefix="custom-select-style-inner"
                                                        name="area_type"
                                                        onChange={(selectedOption) => {
                                                            setFieldValue('area_type', selectedOption.value);
                                                        }}
                                                        value={{
                                                            label: values.area_type,
                                                            value: values.area_type,
                                                        }}
                                                        options={['Carpet area', 'Usable area', 'Gross Leaseable area'].map((item) => ({
                                                            label: item,
                                                            value: item,
                                                        }))}
                                                    />
                                                </div>
                                            </div>
                                            <div className="newGridSectionInner">
                                                <label>Requested Sqft (From)</label>
                                                <div className="position-relative">
                                                    <Field type="text" name="requested_sqft_from" maxlength="10" 
                                                    onInput={(e) => {
                                                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                        }
                                                    }
                                                    />
                                                    {this.validator.message('', values.requested_sqft_from, 'numeric')}
                                                </div>
                                            </div>
                                            <div className="newGridSectionInner">
                                                <label>Requested Sqft (To)</label>
                                                <div className="position-relative">
                                                    <Field type="text" name="requested_sqft_to" maxlength="10" 
                                                        onInput={(e) => {
                                                            e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                            }
                                                        }
                                                    />
                                                    {this.validator.message('', values.requested_sqft_to, 'numeric')}
                                                </div>
                                            </div>
                                            <div className="newGridSectionInner">
                                                <label>Target Price (From)</label>
                                                <div className="position-relative">
                                                    <Field type="text" name="target_price_from" maxlength="10" 
                                                        onInput={(e) => {
                                                            e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                            }
                                                        }
                                                    />
                                                    {this.validator.message('', values.target_price_from, 'numeric')}
                                                </div>
                                            </div>
                                            <div className="newGridSectionInner">
                                                <label>Target Price (To)</label>
                                                <div className="position-relative">
                                                    <Field type="text" name="target_price_to" maxlength="10"
                                                        onInput={(e) => {
                                                            e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                            }
                                                        }
                                                     />
                                                    {this.validator.message('', values.target_price_to, 'numeric')}
                                                </div>
                                            </div>
                                            <div className="newGridSectionInner">
                                                <label>Targeted Markets</label>
                                                <div className="position-relative">
                                                    <Field type="text" name="targeted_markets" maxlength="100" />
                                                </div>
                                            </div>
                                            <div className="gridColOneByThree textWithHrTag">
                                                <hr className="m-0 mt-1" />
                                                <h4>ADD Commissions</h4>
                                            </div>
                                            <div className="newGridSectionInner">
                                                <label>Total Commission</label>
                                                <div className="position-relative">
                                                    <Field type="text" name="total_commission" maxlength="100" />
                                                </div>
                                            </div>
                                            <div className="newGridSectionInner">
                                                <label>My % Split</label>
                                                <div className="position-relative">
                                                    <Field type="text" name="my_split" maxlength="100" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">

                                            <button type="submit" className='add_button' disabled={isSubmitting}>
                                                {isSubmitting && <FontAwesomeIcon icon={faSpinner} className="spinner-icon" />} Submit
                                            </button>
                                        </div>

                                    </div>
                                </Form>
                            </div>
                        </>
                    )
                    }
                </Formik>

                <PopupMessage
                    open={this.state.messsagePopup}
                    content={this.state.popupContent}
                    redirectAfterSave={this.redirectAfterSave}
                />

            </>
        );
    }
}

export default withRouter(LeadAdd);
